import { useRef, useSyncExternalStore } from "react";
import usePostMessageConfig from "./usePostMessageConfig";
import useAnalytics from "../useAnalytics";

const useHasConfig = () => {
	const { getHasConfig, subscribe, getUpdateCount } = usePostMessageConfig();
	const configUpdates = useRef(0);
	const { triggerAnalyticsEvent, ANALYTICS_EVENTS } = useAnalytics();

	return useSyncExternalStore(
		subscribe,
		() => {
			const configUpdateCount = getUpdateCount();

			if (configUpdates.current < configUpdateCount) {
				triggerAnalyticsEvent(ANALYTICS_EVENTS.CONFIG_UPDATED, { updateCount: configUpdateCount });
			}

			configUpdates.current = configUpdateCount;

			return getHasConfig();
		},
	);
};

export default useHasConfig;
